import React, { useState, useMemo } from "react";
import MySkeleton from "components/ui/feedback/Skeleton";
import { useStatsFetch } from "./useStatsApi";
import {
  StatCard,
  SectionCard,
  RefreshButton,
  ErrorMessage,
  SimpleTable,
  RateBar,
  formatNumber,
} from "./StatComponents";

const SchoolLoginRates = () => {
  const { data, isLoading, error, load } = useStatsFetch("/admin/statistics/school-login-rates");
  const [search, setSearch] = useState("");

  const totals = data?.totals;
  const schools = data?.schools || [];

  const filteredSchools = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return schools;
    return schools.filter(
      (s) => s.school.toLowerCase().includes(term) || (s.company || "").toLowerCase().includes(term)
    );
  }, [schools, search]);

  return (
    <SectionCard
      title={`Okul Bazında Giriş Oranları (${formatNumber(filteredSchools.length)} okul)`}
      actions={
        <>
          <input
            type="text"
            placeholder="Okul veya şirket ara..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              padding: "6px 10px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "13px",
              minWidth: "200px",
            }}
          />
          <RefreshButton onClick={() => load()} isLoading={isLoading} />
        </>
      }
    >
      <ErrorMessage message={error} />

      {isLoading && !data ? (
        <MySkeleton lineCount={8} />
      ) : data ? (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "15px", marginBottom: "20px" }}>
            <StatCard label="Toplam Kullanıcı" value={totals?.totalUsers} color="#1976d2" />
            <StatCard
              label="Giriş Yapmış"
              value={totals?.loggedIn}
              sub={
                totals?.totalUsers > 0
                  ? ((totals.loggedIn / totals.totalUsers) * 100).toFixed(1) + "% kullanıcı"
                  : null
              }
              color="#2e7d32"
            />
            <StatCard
              label="Son 30 Günde Görülen"
              value={totals?.seenLast30}
              sub={
                totals?.totalUsers > 0
                  ? ((totals.seenLast30 / totals.totalUsers) * 100).toFixed(1) + "% kullanıcı"
                  : null
              }
              color="#7b1fa2"
            />
            <StatCard label="Telefonu Olan" value={totals?.withPhone} color="#0288d1" />
          </div>

          <SimpleTable
            columns={[
              { key: "school", label: "Okul" },
              { key: "company", label: "Şirket" },
              {
                key: "totalUsers",
                label: "Kullanıcı",
                align: "right",
                render: (row) => formatNumber(row.totalUsers),
              },
              { key: "withPhone", label: "Telefonlu", align: "right", render: (row) => formatNumber(row.withPhone) },
              { key: "loggedIn", label: "Giriş Yapmış", align: "right", render: (row) => formatNumber(row.loggedIn) },
              {
                key: "loginRate",
                label: "Giriş Oranı",
                render: (row) => <RateBar rate={row.totalUsers > 0 ? (row.loggedIn / row.totalUsers) * 100 : 0} />,
              },
              {
                key: "seenLast30",
                label: "Son 30 Gün",
                align: "right",
                render: (row) => formatNumber(row.seenLast30),
              },
              {
                key: "seen30Rate",
                label: "30 Gün Oranı",
                render: (row) => <RateBar rate={row.totalUsers > 0 ? (row.seenLast30 / row.totalUsers) * 100 : 0} />,
              },
            ]}
            rows={filteredSchools}
            emptyText="Okul bulunamadı."
            maxHeight="600px"
            rowKey={(row, idx) => row.schoolId || `no-school-${idx}`}
          />
        </>
      ) : null}
    </SectionCard>
  );
};

export default SchoolLoginRates;
